var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({class:[
		_vm.$s.ProgressBarContainer,
		_vm.$s[("size_" + _vm.resolvedSize)],
		_vm.$s[("shape_" + _vm.resolvedShape)] ],attrs:{"role":"progressbar","aria-valuemin":"0","aria-valuemax":"100","aria-valuenow":_vm.progress}},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{class:[
			_vm.$s.ProgressBar,
			_vm.$s[("shape_" + _vm.resolvedShape)] ],style:(_vm.barStyles)})])}
var staticRenderFns = []

export { render, staticRenderFns }